import { catchError as rxjscatchError, map as rxjsmap } from 'rxjs';
import { BaseServices } from './../../kuba.services';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FDVServices {
    constructor(private http: HttpClient) {
    }

    // list all fdv
    list(businessId: number) {
        return this.http
            .get(
            environment.BASE_URL +
            '/firedeviation/firedeviation/list/' +
            businessId,
            ).pipe(rxjsmap((result:any) => result));
    }

    myList(bId: number, userId: number) {
        return this.http
            .get(
            environment.BASE_URL +
            '/firedeviation/firedeviation/my-list/' +
            bId +
            '/' +
            userId,
            ).pipe(rxjsmap((result:any) => result));
    }
    getFdvByUserId(UserId: number) {
        return this.http
            .get(
            environment.BASE_URL +
            '/firedeviation/firedeviation-user/' +
            UserId,
            ).pipe(rxjsmap(result => result));
    }
    getByFDVId(Id: number) {
        return this.http
            .get(environment.BASE_URL + '/firedeviation/firedeviation/' + Id,).pipe(rxjsmap((result:any) => result));
    }

    getTypeOfObject() {
        return this.http
            .get(environment.BASE_URL + '/businessPropertyTypes', ).pipe(rxjsmap((result: any) => result));
    }

    getUser(id: number) {
        return this.http
            .get(environment.BASE_URL + '/employeecontactusers/' + id, ).pipe(rxjsmap((result: any) => result));
    }

    addFdv(data: any) {
        return this.http
            .post(
            environment.BASE_URL + '/firedeviation/firedeviation',
            data,

            ).pipe(rxjsmap(result => result));
    }
    update(data: any) {
        return this.http
            .put(
            environment.BASE_URL + '/firedeviation/deviation',
            data,

            ).pipe(rxjsmap(result => result));
    }
    delete(id: number) {
        return this.http
            .delete(
            environment.BASE_URL +
            '/firedeviation/firedeviation/delete/' +
            id,
            ).pipe(rxjsmap(result => result)).pipe(rxjscatchError(this.handleError));
    }
    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

    getFdvFeatures(businessId: number) {
        let featureId: number;
        let workingModule = JSON.parse(sessionStorage.getItem('workingModule'));
        featureId = workingModule.id;
        return this.http
            .get(
            environment.BASE_URL + '/business/' + businessId,

            ).pipe(rxjsmap((result:any) => {
                let feature = result.Features;
                let fdvAdditionalFeature = _.find(JSON.parse(feature), {
                    id: featureId,
                    access: true
                });
                return fdvAdditionalFeature;
            }));
    }
}
